import React from 'react';
export function DownloadIcon(props: SVGProps<SVGSVGElement>) {
  return <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" {...props} data-id="element-163">
      <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4" data-id="element-164" />
      <polyline points="7 10 12 15 17 10" data-id="element-165" />
      <line x1="12" y1="15" x2="12" y2="3" data-id="element-166" />
    </svg>;
}